import React, { FC } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import { TypeButtonLinkComponentWithoutUnresolvableLinksResponse } from '@shared/features/contentful/_generated';
import { resolveContentfulTargetProps } from '@shared/features/contentful/linkMap';
import Icon, { IconType } from './Icon';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

interface Props {
    width?: number;
    height?: number;
    data?: TypeButtonLinkComponentWithoutUnresolvableLinksResponse;
    classes?: {
        link?: string;
        linkHover?: string;
        icon?: string;
        iconHover?: string;
    };
}

const ContentfulIcon: FC<Props> = ({ data, width = 24, height = 24, classes }) => {
    const { link, target, icon, style, media } = data?.fields ?? {};
    const alt = data?.fields?.title;
    const inspectorProps = useContentfulInspectorMode({ entryId: data?.sys.id });

    return (
        icon && (
            <div {...inspectorProps({ fieldId: 'title' })}>
                <Link
                    {...resolveContentfulTargetProps(target)}
                    href={link ?? '/'}
                    aria-label={icon}
                    className={classNames(
                        `cursor-pointer flex items-center justify-center ${classes?.link ?? ''}`,
                        {
                            [classes?.linkHover || '']: classes?.linkHover && style === 'Hover',
                        },
                    )}
                >
                    {icon !== 'other' ? (
                        <Icon
                            type={icon as IconType}
                            className={classNames(classes?.icon ?? '', {
                                [classes?.iconHover || '']: classes?.iconHover && style === 'Hover',
                            })}
                            width={width}
                            height={height}
                            alt={alt}
                        />
                    ) : media?.fields?.file?.url ? (
                        <Image
                            src={`https:${media.fields.file.url}`}
                            alt={alt ?? ''}
                            className={classNames(classes?.icon ?? '', {
                                [classes?.iconHover || '']: classes?.iconHover && style === 'Hover',
                            })}
                            width={width}
                            height={height}
                        />
                    ) : null}
                </Link>
            </div>
        )
    );
};

export default ContentfulIcon;
